import { useAuth0 } from '@auth0/auth0-react';
import { css } from '@emotion/core';
import { notification } from 'antd';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Error from '@/pages/_error';
import Container from '@/src/shared/components/Container';
import Section from '@/src/shared/components/Section';
import attachmentHelper from '@/utils/attachmentHelper';
import request from '@/utils/axios';

const style = {
  header: css`
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-bottom: 24px;
  `,
};

const AttachRoute = props => {
  const { isLoggedIn, isLoading, role, area, userinfo, filepath } = props;

  const { loginWithRedirect } = useAuth0();
  const router = useRouter();
  const { query } = router;

  const [unauthorizedError, setUnauthorizedError] = useState(false);
  const _attachmentid = query.slug; // use sitepageid for url route pattern;

  useEffect(() => {
    if (!_attachmentid || (!role?.length && isLoggedIn)) return;
    (async function mounted() {

      try {
        const secureBooleanResponse = await request({
          url: 'attachment/isfilesecure',
          method: 'GET',
          params: {
            area,
            id: _attachmentid,
          },
          triggerLoad: false,
        });

        const secure = secureBooleanResponse.data;

        if (!secure) {
          attachmentHelper(area, _attachmentid, filepath, isLoggedIn, userinfo, isLoading, loginWithRedirect, secure);
          return;
        }

        const response = await request({
        url: 'attachment/filesecurity',
        method: 'GET',
        params: {
         area,
         id: _attachmentid,
        },
         triggerLoad: false,
        });
        const { MemberAccessLevels } = response.data;
        if (MemberAccessLevels?.length !== 0 && !isLoggedIn && !isLoading) {
          loginWithRedirect({
            appState: {
              returnTo: window.location.pathname,
            },
          });
          return;
        }
        if (MemberAccessLevels !== undefined && MemberAccessLevels?.length !== 0) {
          const hasAccessToContent = MemberAccessLevels.some(level =>
            role.includes(level.WebAccessDescription)
          );
          if (!hasAccessToContent) {
            setUnauthorizedError(true);
            return;
          }
          setUnauthorizedError(false);
        }
        attachmentHelper(area, _attachmentid, filepath, isLoggedIn, userinfo, isLoading, loginWithRedirect, secure);
      } catch (err) {
        notification.error({
          message: 'Error',
          description: err.message,
        });
      }
    })();
  }, [_attachmentid, role]);
    
  if (unauthorizedError) return <Error status={401} />;

  return (
    !('wrap_access_token' in query) && (
      <>
        <Section>
          <Container>
            <header css={style.header}>Loading Attachment...</header>
            <p>
              Depending on the web browser and type of attachment, the file will either launch
              automatically or appear in the browser download list. However, if the attachment does
              not exist or you do not have rights to view the attachment, an error message will
              appear in the upper right corner of the browser window.
            </p>
          </Container>
        </Section>
      </>
    )
  );
};

export default connect(
  state => {
    const { auth } = state;
    const { role, isLoggedIn, isLoading, userinfo } = auth;
    return { role, isLoggedIn, isLoading, userinfo };
  },
  null
)(AttachRoute);